import { render } from "./RecentProperty.vue?vue&type=template&id=9478e7ac&ts=true"
import script from "./RecentProperty.vue?vue&type=script&lang=ts"
export * from "./RecentProperty.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__